import { saveAs } from 'file-saver-es';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ReceiptHistory } from "../../../model/receiptHistory";
import { CustomersService } from "../../../services/customers.service";
import { ReceiptPaymentService } from "../../../services/receiptpayment.service";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as _ from "lodash";
import * as moment from "moment";
import { CompanyService } from "../../../services/company.service";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { GeneratePdfComponent } from '../../shared/generate-pdf/generate-pdf.component';
import { tableHeaderCustomStyle } from '../../../config/pdfStyle';
import { getCSVStringOfAttribute, getCurrency, getSumOfAttribute } from '../../../common/commonHelper';
import { UploadFromTemplateService } from '../../../services/upload-from-template.service';
@Component({
  selector: "app-receipthistorylist",
  templateUrl: "./receipthistorylist.component.html",
  styleUrls: ["./receipthistorylist.component.scss"],
  providers: [CustomersService,CompanyService],
})
export class ReceipthistorylistComponent implements OnInit {
  receipts: any[] = [];
  customerPaymentsConstant: any[];
  queryCustomerId: string;
  queryCustomer: any[] = [];
  queryCustomerConstant: any[] = [];
  queryFromDate: Date;
  queryToDate: Date;
  receiptList: any[] = [];
  customerNameIdMap= {};
  queryCustomerName: string;
  companyData: any[] = [];
  customerData: any[] = [];
  readonly allowedPageSizes = [20, 50, 100, "all"];
  getSumOfAttribute = getSumOfAttribute;
  getCSVStringOfAttribute = getCSVStringOfAttribute;
  getCurrency = getCurrency;

  constructor(
    private router: Router,
    private _customerService: CustomersService,
    private _receiptpaymentservice: ReceiptPaymentService,
    public companyService: CompanyService,
    private _makePdfService: GeneratePdfComponent,
    private _uploadFromTemplateService: UploadFromTemplateService,
  ) {
    (window as any).pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }

  ngOnInit() {
    this.getData();
    this.getCompantData();
  }
  private getData() {
    this.queryCustomerId = "";
    this._customerService.getCustomersData().subscribe((data) => {
      // this.queryCustomer = data.result;
      // this.queryCustomerConstant = data.result;
      this.customerData = data.result;
      for (var i = 0; i < data.result.length; i++) {
        if (data.result[i].name != undefined) {
          this.queryCustomer.push(data.result[i]);
          this.queryCustomerConstant.push(data.result[i]);
          this.customerNameIdMap[data.result[i].name] = data.result[i]._id;
        }
      }
    });
    this._receiptpaymentservice.getCustomerReceipt().subscribe((data) => {
      this.receipts = data.result;
      this.customerPaymentsConstant = data.result;
      this.getPaymentList();
      this.receiptList = _.orderBy(
        this.receiptList,
        (p) => Date.parse(p.createdAt),
        "desc"
      );
    });
  }

 getCompantData(){
  this.companyService.getCompanyData().subscribe((data) => {
    this.companyData = data.result;
  });
 }

  viewInvoice(data){
    let invoiceInfo = data;
    const company = this.companyData.find(
      (company) => company._id === localStorage.getItem("selectedCompany")
    );
    const customer = this.customerData.find(
      (customer) => customer._id === invoiceInfo.customerId
    );

    // let invoiceLineItems = data.invoiceItemDetails;


    invoiceInfo["companyName"] = company.name;
    invoiceInfo["companyAddress"] = company.address.fullAddress;
    invoiceInfo["customerAddress"] = customer.CustomerAddress ? customer.CustomerAddress.fullAddress : "-";


    let invoiceItemsData: any[][] = [
      [

        {
          text: 'Load #',
          style: tableHeaderCustomStyle
        },
        {
          text: 'Payment Method',
          style: tableHeaderCustomStyle
        },
        {
          text: 'Invoice Amount',
          alignment: 'right',
          style: tableHeaderCustomStyle
        },
        {
          text: 'Remaining Amount',
          alignment: 'right',
          style: tableHeaderCustomStyle
        },
        {
          text: 'Paid Amount',
          alignment: 'right',
          style: tableHeaderCustomStyle
        }
      ]]

    invoiceInfo?.lineItem.forEach((lineItem) => {
      let columnsObj = [
        { text: lineItem?.loadNumber, alignment: 'left', margin: [0, 5, 0, 5] },
        { text: invoiceInfo.paymentMethod, alignment: 'left', margin: [0, 5, 0, 5] },
        { text: getCurrency(lineItem?.invoiceAmount), alignment: 'right', margin: [0, 5, 0, 5] },
        { text: getCurrency(lineItem?.remainingAmount), alignment: 'right', margin: [0, 5, 0, 5] },
        { text: getCurrency(lineItem?.amount), alignment: 'right', margin: [0, 5, 0, 5] },
      ]
      invoiceItemsData.push(columnsObj);
    });

    let totalAmount = invoiceInfo.lineItem.reduce((acc: number, curr: any) => acc + curr.amount, 0);

    // this.generatePDF(invoiceInfo, invoiceItemsData, totalAmount);
    const pdfData = {
      invoiceHeader: invoiceInfo,
      invoiceItemsData: invoiceItemsData,
      widths: [40, '*', '*', '*', 80],
      total: totalAmount,
      invoiceType: 'Receipt No'
    }
    this._makePdfService.generateReceiptPDF(pdfData) ;

  }
  generatePDF(invoiceInfo, invoiceItemsData, total) {
    var dd = {

      content: [
        {
          columns: [
            [
              {
                text: 'Receipt',
                color: '#333333',
                width: '*',
                fontSize: 28,
                bold: true,
                alignment: 'right',
                margin: [0, 0, 0, 15],
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: 'Invoice #',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: invoiceInfo.invoiceId,
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  },
                 /*  {
                    columns: [
                      {
                        text: 'Invoice Date',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: moment().format("MM/DD/YYYY"),
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  }, */
                  {
                    columns: [
                      {
                        text: 'Payment Date',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: moment(invoiceInfo.paymentDate).format("MM/DD/YYYY"),
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  }
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: 'From',
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
            {
              text: 'Payment To',
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
          ],
        },
        {
          columns: [
            {
              text: invoiceInfo.customer,
              bold: true,
              color: '#333333',
              alignment: 'left',
            },
            {
              text: invoiceInfo.companyName,
              bold: true,
              color: '#333333',
              alignment: 'left',
            },
          ],
        },
        {
          columns: [
            {
              text: 'Address',
              color: '#aaaaab',
              bold: true,
              margin: [0, 7, 0, 3],
            },
            {
              text: 'Address',
              color: '#aaaaab',
              bold: true,
              margin: [0, 7, 0, 3],
            },
          ],
        },
        {
          columns: [
            {
              text: invoiceInfo.customerAddress,
              style: 'invoiceBillingAddress',
            },
            {

              text: invoiceInfo.companyAddress,
              style: 'invoiceBillingAddress',
            },
          ],
        },
        '\n\n',
        // {
        //   width: '100%',
        //   alignment: 'center',
        //   text: 'Invoice Number : ' + invoiceInfo.invoiceId,
        //   bold: true,
        //   margin: [0, 10, 0, 10],
        //   fontSize: 15,
        // },
        {
          layout: {
            defaultBorder: false,
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 1;
            },
            hLineColor: function (i, node) {
              if (i === 1 || i === 0) {
                return '#bfdde8';
              }
              return '#eaeaea';
            },
            vLineColor: function (i, node) {
              return '#eaeaea';
            },
            hLineStyle: function (i, node) {
              // if (i === 0 || i === node.table.body.length) {
              return null;
              //}
            },
            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            paddingLeft: function (i, node) {
              return 10;
            },
            paddingRight: function (i, node) {
              return 10;
            },
            paddingTop: function (i, node) {
              return 2;
            },
            paddingBottom: function (i, node) {
              return 2;
            },
            fillColor: function (rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {
            headerRows: 1,
            widths: [40, '*', '*', '*', 80],
            body: invoiceItemsData,
            // [
            //   {
            //     text: 'Load Number',
            //     fillColor: '#eaf2f5',
            //     border: [false, true, false, true],
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            //   {
            //     text: 'Customer Ref',
            //     fillColor: '#eaf2f5',
            //     border: [false, true, false, true],
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            //   {
            //     text: 'Shipper Ref',
            //     fillColor: '#eaf2f5',
            //     border: [false, true, false, true],
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            //   {
            //     text: 'Description',
            //     fillColor: '#eaf2f5',
            //     border: [false, true, false, true],
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            //   {
            //     text: 'Amount',
            //     border: [false, true, false, true],
            //     alignment: 'right',
            //     fillColor: '#eaf2f5',
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            // ],

            // [
            //   {
            //     text: invoiceInfo.loadNumber,
            //     border: [false, false, false, true],
            //     margin: [0, 5, 0, 5],
            //     alignment: 'left',
            //   },
            //   {
            //     text: invoiceInfo.loadId.crefNo,
            //     border: [false, false, false, true],
            //     margin: [0, 5, 0, 5],
            //     alignment: 'left',
            //   },
            //   {
            //     text: 'Item 1',
            //     border: [false, false, false, true],
            //     margin: [0, 5, 0, 5],
            //     alignment: 'left',
            //   },
            //   {
            //     text: invoiceInfo.loadId.srefNo,
            //     border: [false, false, false, true],
            //     margin: [0, 5, 0, 5],
            //     alignment: 'left',
            //   },
            //   {
            //     border: [false, false, false, true],
            //     text: invoiceInfo.invoiceAmount,
            //     fillColor: '#f5f5f5',
            //     alignment: 'right',
            //     margin: [0, 5, 0, 5],
            //   },
            // ],

          },
        },
        '\n',
        '\n\n',
        {
          layout: {
            defaultBorder: false,
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 1;
            },
            hLineColor: function (i, node) {
              return '#eaeaea';
            },
            vLineColor: function (i, node) {
              return '#eaeaea';
            },
            hLineStyle: function (i, node) {
              // if (i === 0 || i === node.table.body.length) {
              return null;
              //}
            },
            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            paddingLeft: function (i, node) {
              return 10;
            },
            paddingRight: function (i, node) {
              return 10;
            },
            paddingTop: function (i, node) {
              return 3;
            },
            paddingBottom: function (i, node) {
              return 3;
            },
            fillColor: function (rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {
            headerRows: 1,
            widths: ['*', 80],
            body: [
              [
                {
                  text: 'Total Amount',
                  bold: true,
                  fontSize: 15,
                  alignment: 'right',
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: '$ ' + total.toLocaleString(2),
                  bold: true,
                  fontSize: 15,
                  alignment: 'right',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 5, 0, 5],
                },
              ],
            ],
          },
        },
        /* '\n\n',
        {
          text: 'Note : This is system generated invoice.',
          style: 'notesTitle',
        },
        '\n\n',
        {
          text: 'Autorized Signature',
          style: 'notesText',
        }, */
      ],
      styles: {
        notesTitle: {
          fontSize: 10,
          bold: true,
          margin: [0, 50, 0, 3],
        },
        notesText: {
          fontSize: 10,
        },
      },
      defaultStyle: {
        columnGap: 20,
        //font: 'Quicksand',
      },
    };

    //pdfMake.createPdf(dd).download();
    pdfMake.createPdf(dd).open();
    //pdfMake.createPdf(dd).print();

  }
  getPaymentList() {
    this.receiptList = this.receipts?.map((receipt) => {
      return {
        ...receipt,
        lineItem: receipt.lineItem.map((singleLine) => {
          return {
            ...singleLine,
            invoiceAmount: singleLine.remainingAmount,
            remainingAmount:
              Number(singleLine.remainingAmount) - Number(singleLine.amount)
          }
        })
      }
    });
    // this.receipts.forEach((receipt) => {
    //   receipt.lineItem.forEach((singleLine) => {
    //     let receipthistory = new ReceiptHistory();
    //     receipthistory.customer = receipt.customerName;
    //     receipthistory.customerId = receipt.customerId;
    //     receipthistory.paymentDate = receipt.paymentDate;
    //     receipthistory.receivedAmount = receipt.remainingAmount;
    //     receipthistory.invoiceId = singleLine.invoiceId;
    //     receipthistory.amount = singleLine.amount;
    //     receipthistory.paymentMethod = receipt.paymentMethod;
    //     receipthistory.ErpPaymentLogNo = receipt.ErpPaymentLogNo;
    //     receipthistory.loadNumber = singleLine.loadNumber;
    //     receipthistory.invoiceAmount = singleLine.remainingAmount;
    //     receipthistory.remainingAmount =
    //       Number(singleLine.remainingAmount) - Number(singleLine.amount);
    //     this.receiptList.push(receipthistory);
    //   });
    // });
  }
  onCustomerChange(value: string) {
    if (value != "" && value != undefined) {
      const filterValue = value.replace(/[\W_]/g, "").toLowerCase();
      this.queryCustomer = this.queryCustomerConstant.filter((option) =>
        option.name.replace(/[\W_]/g, "").toString().toLowerCase().includes(filterValue)
      );
    } else {
      this.queryCustomerId = "";
      this.queryCustomer = this.queryCustomerConstant;
    }
  }
  onCustomerSelected(customerName){
    if (customerName != "") {
      this.queryCustomerId = this.customerNameIdMap[customerName];
    }
  }
  onReset(){
    this.queryCustomerId = "";
    this.queryCustomerName = "";
    this.queryFromDate = new Date("1000-01-01");
    this.queryToDate = new Date("9999-01-01");
    this.getData();
  }
  onSearch() {
    if (typeof this.queryFromDate === "undefined")
      this.queryFromDate = new Date("1000-01-01");

    if (typeof this.queryToDate === "undefined")
      this.queryToDate = new Date("9999-01-01");

    this.receipts = this.customerPaymentsConstant;

    if (this.queryCustomerId != "") {
      this.receipts = this.receipts.filter((receipt) => {
        return (
          receipt.customerId === this.queryCustomerId &&
          new Date(receipt.paymentDate).getTime() >=
            new Date(this.queryFromDate).getTime() &&
          new Date(receipt.paymentDate).getTime() <=
            new Date(this.queryToDate).getTime()
        );
      });
      this.getPaymentList();
    } else {
      this.receipts = this.receipts.filter((receipt) => {
        return (
          new Date(receipt.paymentDate).getTime() >=
            new Date(this.queryFromDate).getTime() &&
          new Date(receipt.paymentDate).getTime() <=
            new Date(this.queryToDate).getTime()
        );
      });
      this.getPaymentList();
    }
  }

  mapDataForDisplay(data: any[]) {
    console.log(data)
    return data.map((item) => {
      return {
        paymentDate: moment(item.paymentDate).format("MM/DD/YYYY"),
        customer: item.customerName,
        invoiceId:  item.lineItem?.map((i) => `${i.invoiceId}`).join(', '),
        loadNumber: item.lineItem?.map((i) => `${i.loadNumber}`).join(', '),
        ErpPaymentLogNo: item?.ErpPaymentLogNo,
        invoiceAmount:  getCurrency(this.getSumOfAttribute(item?.lineItem, 'invoiceAmount')),
        amount: getCurrency(this.getSumOfAttribute(item?.lineItem, 'amount')),
        remainingAmount: getCurrency(this.getSumOfAttribute(item?.lineItem, 'remainingAmount'))
      };
    });
  }

  onExporting(e) {
    const gridInstance = e.component;
    const columns = gridInstance.option("columns");
    const data = this.mapDataForDisplay(this.receiptList);
    this._uploadFromTemplateService.exportData(columns, data, 'Receipt History');
    e.cancel = true;
  }
}
